import React from 'react';
import {
  Box,
  Button,
  Divider,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stat,
  StatLabel,
  StatNumber,
  Text,
  VStack,
} from '@chakra-ui/react';
import { FiXCircle } from 'react-icons/fi';
import { SaktiAccessCodeRequest } from '../types';
import { SAKTI_UI_SIZE } from '../uiSizes';

interface SaktiAccessCodeDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  request: SaktiAccessCodeRequest | null;
  code: string | null;
  loadingCode: boolean;
  onCancel: (id: string) => void;
  cancelling: boolean;
}

const SaktiAccessCodeDetailModal: React.FC<SaktiAccessCodeDetailModalProps> = ({
  isOpen,
  onClose,
  request,
  code,
  loadingCode,
  onCancel,
  cancelling,
}) => {
  if (!request) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="md">
      <ModalOverlay />
      <ModalContent borderRadius={SAKTI_UI_SIZE.cardRadius}>
        <ModalHeader bg="customGreen.500" color="white" borderRadius={`${SAKTI_UI_SIZE.cardRadius} ${SAKTI_UI_SIZE.cardRadius} 0 0`}>
          Detail Kode Akses
        </ModalHeader>
        <ModalCloseButton color="white" />
        <ModalBody py={6}>
          <VStack spacing={4} align="stretch">
            <Box>
              <Text fontSize="xs" color="gray.500" fontWeight="bold" mb={1}>KARYAWAN</Text>
              <Text fontWeight="semibold">{request.employee_name} ({request.nip})</Text>
            </Box>
            
            <Box>
              <Text fontSize="xs" color="gray.500" fontWeight="bold" mb={1}>DEVICE</Text>
              <Text>{request.device_model}</Text>
            </Box>

            <Divider />

            <Box bg="gray.50" p={4} borderRadius="lg" textAlign="center">
              <Stat>
                <StatLabel color="gray.500">KODE AKSES</StatLabel>
                <StatNumber fontSize="4xl" letterSpacing="widest" color="customGreen.600">
                  {loadingCode ? '...' : (code || 'TIDAK TERSEDIA')}
                </StatNumber>
              </Stat>
              {request.status === 'PENDING' && (
                <Text fontSize="xs" color="orange.600" mt={2} fontWeight="medium">
                  Berlaku sampai {new Date(request.expires_at).toLocaleTimeString('id-ID')}
                </Text>
              )}
            </Box>

            <Box>
              <Text fontSize="xs" color="gray.500" textAlign="center">
                Berikan kode di atas kepada karyawan untuk aktivasi perangkat.
                Sistem mencatat akses kode ini ke dalam Audit Log.
              </Text>
            </Box>
          </VStack>
        </ModalBody>
        <ModalFooter bg="gray.50" borderRadius={`0 0 ${SAKTI_UI_SIZE.cardRadius} ${SAKTI_UI_SIZE.cardRadius}`}>
          <HStack spacing={3} w="100%">
            <Button
              flex={1}
              variant="outline"
              colorScheme="red"
              leftIcon={<FiXCircle />}
              onClick={() => onCancel(request.id)}
              isLoading={cancelling}
              isDisabled={request.status !== 'PENDING'}
            >
              Batalkan Request
            </Button>
            <Button flex={1} bg="customGreen.500" color="white" _hover={{ bg: 'customGreen.600' }} onClick={onClose}>
              Tutup
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SaktiAccessCodeDetailModal;
